import React from 'react'

import Schedule from './Schedule'

// Modules
import { getSwitchingsFromChamp, getRotationsFromChamp } from '../../../utils/confrontationsFunctions';

class ScheduleContainer extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            champObject: this.props.champObject,
            schedules: [],
        }
    }

    componentDidMount = () => {
        this.getSchedule(this.state.champObject)
    }

    getSchedule = async (champ) => {
        this.setState({
            schedules: [],
            loading: true,
            startChamp: champ.startChamp * 60
        })

        let key = this.props.champId;

        let switchingsArray = await getSwitchingsFromChamp(key);

        // Set default confrontationTime and confrontationPerTime
        let confrontationTime = champ.confrontationTime || 5;
        let confrontationPerTime = champ.confrontationPerTime || 1;

        let localArrayOfSwitchings = [];
        switchingsArray.forEach(switching => {
            if (switching.index <= 100 || switching.index >= 109) {
                /* Check if has competitor in fases to calculate time of each switching */
                let timeTotal = 0
                let count = 0

                if (switching.roundOf32 !== undefined) {
                    switching.roundOf32.forEach(snap => { if (snap.nome !== '') { count++ } })
                    if (count !== 0) {
                        timeTotal += Math.ceil(Math.floor(count / 2) / confrontationPerTime) * confrontationTime
                        timeTotal += Math.ceil(Math.floor(count / 4) / confrontationPerTime) * confrontationTime
                        timeTotal += Math.ceil(Math.floor(count / 8) / confrontationPerTime) * confrontationTime
                        timeTotal += Math.ceil(Math.floor(count / 16) / confrontationPerTime) * confrontationTime
                        timeTotal += Math.ceil(Math.floor(count / 32) / confrontationPerTime) * confrontationTime
                    }
                }

                //round of 16
                switching.roundOf16.forEach(snap => { if (snap.nome !== '') { count++ } })
                if (count !== 0) {
                    timeTotal += Math.ceil(Math.floor(count / 2) / confrontationPerTime) * confrontationTime
                    timeTotal += Math.ceil(Math.floor(count / 4) / confrontationPerTime) * confrontationTime
                    timeTotal += Math.ceil(Math.floor(count / 8) / confrontationPerTime) * confrontationTime
                    timeTotal += Math.ceil(Math.floor(count / 16) / confrontationPerTime) * confrontationTime
                }

                //quarter finals
                if (count === 0) {
                    switching.quarterFinals.forEach(snap => { if (snap.nome !== '') { count++ } })
                    if (count !== 0) {
                        timeTotal += Math.ceil(Math.floor(count / 2) / confrontationPerTime) * confrontationTime
                        timeTotal += Math.ceil(Math.floor(count / 4) / confrontationPerTime) * confrontationTime
                        timeTotal += Math.ceil(Math.floor(count / 8) / confrontationPerTime) * confrontationTime
                    }
                }

                //semi finals
                if (count === 0) {
                    switching.semiFinals.forEach(snap => { if (snap.nome !== '') { count++ } })
                    if (count !== 0) {
                        timeTotal += Math.ceil(Math.floor(count / 2) / confrontationPerTime) * confrontationTime
                        timeTotal += Math.ceil(Math.floor(count / 4) / confrontationPerTime) * confrontationTime
                    }
                }

                //final
                if (count === 0) {
                    switching.final.forEach(snap => { if (snap.nome !== '') { count++ } })
                    if (count !== 0) {
                        timeTotal += Math.ceil(Math.floor(count / 2) / confrontationPerTime) * confrontationTime
                    }
                }

                let localObj = switching
                if (switching.index >= 109)
                    localObj['id'] = 'E - ' + (switching.index - 108)
                else
                    localObj['id'] = parseInt(switching.index, 10)

                let localHour = Math.floor(this.state.startChamp / 60)
                let localMin = this.state.startChamp % 60
                localObj['hora'] = (localHour < 10 ? '0' + localHour : localHour) + 'h' + (localMin < 10 ? '0' + localMin : localMin)

                this.setState({ startChamp: (this.state.startChamp + timeTotal) })

                if (count !== 0)
                    localArrayOfSwitchings.push(localObj)

            }
        })

        /* Get all rotation */
        let rotations = await getRotationsFromChamp(key);
        let count2 = 1;
        rotations.forEach(rotation => {
            let localHour = Math.floor(this.state.startChamp / 60);
            let localMin = this.state.startChamp % 60;

            this.setState({ startChamp: (this.state.startChamp + 30) });

            if (rotation.competitors[0].nome !== '') {
                localArrayOfSwitchings.push({
                    id: 'R - ' + count2,
                    idade: '',
                    sexo: '',
                    faixa: '',
                    peso: '',
                    hora: (localHour < 10 ? '0' + localHour : localHour) + 'h' + (localMin < 10 ? '0' + localMin : localMin)
                });
            }
        });

        /* Order Array */
        localArrayOfSwitchings.sort(this.compare)

        this.setState({
            schedules: localArrayOfSwitchings,
            loading: false
        });
    }

    compare = (a, b) => {
        if (a.id < b.id)
            return -1;
        if (a.id > b.id)
            return 1;
        return 0;
    }

    render() {

        return (
            <Schedule
                loading={this.state.loading}
                schedules={this.state.schedules}
            />
        )
    }
}

export default ScheduleContainer